import axios from '@/router/axios.js';
export const getAnswer = params => {
  return axios({
    url: '/api/surveyFormInfo/getFormInfoVOById',
    method: 'get',
    params
  });
};
export const submit = data => {
  return axios({
    url: '/api/surveyQuestionnaireReleaseRecord/insertReleaseRecordData',
    method: 'POST',
    data
  });
};
export const validPhone = params => {
  return axios({
    url: '/api/surveyCollegePhone/insertCollegePhone',
    params
  });
};

export const getValidCodeApi = params => {
  return axios({
    // url: '/api/image/getImage',
    url: '/api/common/verificationCode',
    params
  });
};
// 判断用户类别
export const getUserType = params => {
  return axios({
    url: '/api/teacherFormInfoRela/isTeacherForm',
    params
  });
};



// WEBPACK FOOTER //
// ./src/api/answer.js